export const EQUITY_LIMIT = {
	KFT: 3_000_000,
	ZRT: 5_000_000,
	NYRT: 20_000_000,
};
